import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.75 8.255a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1-.75-.75m0 3a.75.75 0 0 1 .75-.75H12a.75.75 0 0 1 0 1.5H7.5a.75.75 0 0 1-.75-.75"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.848 2.776A49 49 0 0 1 12 2.255c2.43 0 4.817.177 7.152.52C21.13 3.067 22.5 4.8 22.5 6.746v6.02c0 1.945-1.37 3.678-3.348 3.969a49 49 0 0 1-3.476.384.39.39 0 0 0-.297.17l-2.755 4.133a.75.75 0 0 1-1.248 0l-2.755-4.133a.39.39 0 0 0-.297-.17 49 49 0 0 1-3.476-.384C2.87 16.443 1.5 14.71 1.5 12.764V6.745c0-1.946 1.37-3.678 3.348-3.97m7.152.98c-2.356 0-4.67.172-6.933.505C3.877 4.435 3 5.49 3 6.745v6.019c0 1.256.877 2.31 2.067 2.486q1.666.245 3.369.372a1.89 1.89 0 0 1 1.433.834L12 19.653l2.131-3.197a1.89 1.89 0 0 1 1.433-.834 47 47 0 0 0 3.37-.372c1.19-.175 2.066-1.23 2.066-2.486V6.745c0-1.256-.877-2.31-2.067-2.485A48 48 0 0 0 12 3.755",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }